/* tslint:disable */
/* eslint-disable */
/**
 * Project Freelancer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateQuoteFreelancerExternalReferenceRequest
 */
export interface UpdateQuoteFreelancerExternalReferenceRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateQuoteFreelancerExternalReferenceRequest
     */
    freelancerExternalReference: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateQuoteFreelancerExternalReferenceRequest
     */
    adminComment?: string;
}

/**
 * Check if a given object implements the UpdateQuoteFreelancerExternalReferenceRequest interface.
 */
export function instanceOfUpdateQuoteFreelancerExternalReferenceRequest(value: object): value is UpdateQuoteFreelancerExternalReferenceRequest {
    if (!('freelancerExternalReference' in value) || value['freelancerExternalReference'] === undefined) return false;
    return true;
}

export function UpdateQuoteFreelancerExternalReferenceRequestFromJSON(json: any): UpdateQuoteFreelancerExternalReferenceRequest {
    return UpdateQuoteFreelancerExternalReferenceRequestFromJSONTyped(json, false);
}

export function UpdateQuoteFreelancerExternalReferenceRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateQuoteFreelancerExternalReferenceRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'freelancerExternalReference': json['freelancerExternalReference'],
        'adminComment': json['adminComment'] == null ? undefined : json['adminComment'],
    };
}

export function UpdateQuoteFreelancerExternalReferenceRequestToJSON(value?: UpdateQuoteFreelancerExternalReferenceRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'freelancerExternalReference': value['freelancerExternalReference'],
        'adminComment': value['adminComment'],
    };
}

